import { useEffect } from 'react';
import './VideoStream.css';

const VideoStream = ({ videoRef, isActive }) => {
  useEffect(() => {
    const videoElement = videoRef.current;
    const startCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: { 
            facingMode: 'environment'
          } 
        });
        if (videoElement) {
          videoElement.srcObject = stream;
        }
      } catch (err) {
        console.error('Ошибка доступа к камере:', err);
      }
    };

    if (isActive) {
      startCamera();
    }

    return () => {
      if (videoElement?.srcObject) {
        const tracks = videoElement.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, [isActive, videoRef]);

  if (!isActive) return null;

  return (
    <video 
      ref={videoRef}
      autoPlay
      playsInline
      className="video-stream"
    />
  );
};

export default VideoStream; 